




























import Vue from 'vue'
import Component from 'vue-class-component'
import OccupationListItem from '@app/componentlib/src/views/components/OccupationListItem.vue'
import { IPreviousJobtitle, IWizardStepPreviousJobs } from '@app/componentlib/common/types/WizardTypes'
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch'
import { JobMatchOccupationModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatchOccupations'
import { IJobMatchProfile, IOccupation } from '@app/componentlib/common/types/JobMatchTypes'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { ProfileModule } from '@app/componentlib/src/store/modules/profile'
import { ProfileData } from '@app/componentlib/common/types/profileTypes'

@Component<WizardStepJobMatchPreviousJobtitles>({
  props: {
    wizardstep: Object
  },
  components: {
    OccupationListItem
  }
})

export default class WizardStepJobMatchPreviousJobtitles extends Vue {
  /**
   * Props variables
   */
  wizardstep: IWizardStepPreviousJobs | undefined

  /**
   * Component state variables
   */
  previousJobTitles: IPreviousJobtitle[] = []

  /**
   * Lifecycle
   */
  mounted() {
    if (this.experiences !== undefined) {
      this.experiences.find((x: any) => {
        let alreadyAdded = this.previousJobTitles.find(p => p.text.toLowerCase() == x.level.toLowerCase())
        if (!alreadyAdded) {
          this.previousJobTitles.push({
            text: x.level,
            isActive: false,
            occupationCode: x.occupationCode
          })
        }
      })

      this.previousJobTitles.find(x => {
        if (this.selectedOccupations.find(o => o.label === x.text && o.occupationSource === 'PreviousExperience'))
          x.isActive = true
        else
          x.isActive = false
      })
    }
  }

  /**
   * Getters
   */
   get jobmatchProfile (): IJobMatchProfile {
    return JobMatchModule.jobMatchProfile
  }

  get selectedOccupations (): IOccupation[] {
    return JobMatchOccupationModule.selectedOccupations
  }

  get profileLink (): string | undefined {
    return AppModule.portalSettings.profileLink  + '#experience'
  }

  get profileData(): ProfileData | undefined {
    return ProfileModule.profileData
  }

  get experiences () {
    if (this.profileData) return this.profileData.experiences.workExperiences
    return undefined
  }

  /**
   * Methods
   */
  buttonClicked() {
    this.$emit('buttonClicked')
  }

}
